import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "12",
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.61963 7.23314L4.78004 10.3936C5.08766 10.7022 5.58806 10.7022 5.89567 10.3946L5.89672 10.3936L14.8196 1.47065V1.38005",
      fill: "#F2F2F2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.61963 7.23314L4.78004 10.3936C5.08766 10.7022 5.58806 10.7022 5.89567 10.3946L5.89672 10.3936L14.8196 1.47065V1.38005",
      stroke: "black",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }